import { Injectable } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { Observable } from "rxjs";
import { CountdownDialogOptions } from "./countdown-dialog";
import { CountdownDialogComponent } from "./countdown-dialog.component";


@Injectable()
export class CountdownDialogService {

    constructor(private matDialog: MatDialog) {}

    // #region Close All Dialogs Service Call

    CloseAllDialogs(): void {
        this.matDialog.closeAll();
    }

    // #endregion

    // #region Open Countdown Dialog Service Call

    Open(options?: CountdownDialogOptions): Observable<boolean> {
        const self = this;

        const dlgoptions: MatDialogConfig<any> = {
            disableClose: true,
            data: {
                TitleText: 'Please Wait...',
                MessageText: '',
                OKText: 'Log Out',
                CancelText: 'Stay Logged In',
                Time: 100,
                ...options,
            },
            width: '500px',
            height: '18rem',
            maxHeight: '85vh',
        };

        // if (self.smallMediaSize) {
        //     dlgoptions.width = '80vw';
        //     // dlgoptions.height = '80vh';
        //     dlgoptions.height = '30rem';
        //     dlgoptions.panelClass = 'smalldialogpanel';
        // }

        const openHandle = this.matDialog.open<CountdownDialogComponent>(CountdownDialogComponent, dlgoptions);

        return openHandle.afterClosed();
    }
}